import React from 'react'
import { useParams } from 'react-router-dom';

const Calendar = () => {
    const { seriesId } = useParams();

    return (
        <div>{seriesId} Series Calendar</div>
    )
}

export default Calendar